module.exports = __webpack_public_path__ + "img/email-clients.aec83f42.svg";